<template>
    <div>
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>

        <div class="animated fadeIn">
            <loader v-if="loading"></loader>

            <div v-if="!loading">
                <component-header
                    title="Templates"
                    :isLoading="isloading"
                    @reload-data="reloadData"
                    @create-press="$router.push({ path: 'notification-template/create' })"
                    :hasback="false"
                    :hasOption="true"
                    :isCreate="false"
                    @search-query="val => (filter = val)"
                />

                <b-card class="card-wrap" border-variant="info">
                    <div>
                        <b-table
                            style="border-radius: 12px"
                            :items="filteredTemplates"
                            :fields="templateColumns"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            hover
                            bordered
                            responsive
                            show-empty
                            class="mt-3 tableRadius"
                            thead-class="header"
                        >

                            <template #cell(SlNo)="data">
                                {{ data.index + 1 }}
                            </template>

                            <template #cell(body)="data">
                                {{ showBody(data.item) }}
                            </template>

                            <template #cell(action)="data">
                                <div class="inline_btnTable">
                                    <b-button
                                        v-if="data.item"
                                        @click="deleteRule(data.item)"
                                        size="sm"
                                        class="mr-2 circle-btn"
                                        variant="danger"
                                    >
                                        <i class="fas fa-trash-alt"></i>
                                    </b-button>
                                </div>
                            </template>

                            <template #empty>
                                <div class="text-center">
                                    {{ isloading ? "Loading..." : "No data available." }}
                                </div>
                            </template>

                        </b-table>
                    </div>

                    <div class="float-right">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="filteredTemplates.length"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        />
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "NotificationTemplateList",

    data() {
        return {
            filter: "",
            loading: false,
            isloading: false,
            currentPage: 1,
            perPage: 8,
            sortBy: "createdAt",
            sortDesc: true,

            templateColumns: [
                { key: "SlNo", label: "Sl No" },
                { key: "service", label: "Type" },
                { key: "concern" },
                { key: "body" },
                { key: "action", thStyle: { width: "8%" } },
            ],
        };
    },

    components: {
        ComponentHeader,
        AtomSpinner,
        loader,
    },

    computed: {
        ...mapGetters({
            getFetchTemplateList: "emailTemplate/GetFetchTemplateList",
        }),

        filteredTemplates() {
            if (!Array.isArray(this.getFetchTemplateList)) return [];

            return this.getFetchTemplateList.filter(el => {
                const text = (el.service + el.concern + el.body)?.toLowerCase() || "";
                return text.includes(this.filter.toLowerCase());
            });
        },
    },

    methods: {
        editRule(data) {
            this.$router.push({
                name: "templateSetupEdit",
                params: { id: data._id },
            });
        },

        showBody(data) {
            if (data.service === "WHATSAPP") {
                let bodyComponent = data.components?.find(
                    c => c.type === "body"
                );
                let textBody = bodyComponent?.parameters?.map(p => p.text);
                return textBody?.join(", ") || "";
            }
            return data.body;
        },

        async reloadData() {
            this.isloading = true;
            await this.$store.dispatch("emailTemplate/fetchTemplateAction");
            this.templateList = this.getFetchTemplateList;
            this.isloading = false;
        },

        async deleteRule(data) {
            this.$swal({
                title: "Delete this Template?",
                text: "Are you sure? This will be removed.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then(async result => {
                if (result.value) {
                    this.isloading = true;

                    await this.$store.dispatch("emailTemplate/deleteTemplate", data._id);

                    this.$swal({
                        type: "success",
                        title: "Deleted",
                        text: "Template deleted successfully!",
                    });

                    await this.reloadData();
                    this.isloading = false;
                }
            });
        },
    },

    async mounted() {
        this.loading = true;
        await this.$store.dispatch("emailTemplate/fetchTemplateAction");
        this.loading = false;
    },

    async activated() {
        await this.reloadData();
    },
};
</script>


<style scoped>

.action-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px; 
}

.circle-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.text-center {
    text-align: center;
}

</style>
